import { emRateConfig, wavesEmRateConfig, xpitchEmRateConfig, keynoteConfig } from './data';

// 获取基调音阶参数
export const getEmketNote = (emPlugsV3, emKeynote, emKey) => {
    const result = {
        vst2: [],
        vst3: [],
    }
    console.log(emKeynote, emKey);
    if (Array.isArray(emPlugsV3.emPlugs)) {
        result.vst2 = filterKeynote(emPlugsV3.emPlugs, emKeynote, emKey)
    }
    if (Array.isArray(emPlugsV3.emVst3Plugs)) {
        result.vst3 = filterKeynote(emPlugsV3.emVst3Plugs, emKeynote, emKey)
    }
    return result.vst2.concat(result.vst3)
}

// 获取升降调参数
export const getEmTune = (emPlugsV3, tune) => {
    const result = {
        vst2: [],
        vst3: [],
    }
    if (Array.isArray(emPlugsV3.emPlugs)) {
        result.vst2 = filterTune(emPlugsV3.emPlugs, tune)
    }
    if (Array.isArray(emPlugsV3.emVst3Plugs)) {
        result.vst3 = filterTune(emPlugsV3.emVst3Plugs, tune)
    }
    return result.vst2.concat(result.vst3)
}
// 获取速率参数
export const getEmRate = (emPlugsV3, value) => {
    const result = {
        vst2: [],
        vst3: [],
    }
    if (Array.isArray(emPlugsV3.emPlugs)) {
        result.vst2 = filterRate(emPlugsV3.emPlugs, value)
    }
    if (Array.isArray(emPlugsV3.emVst3Plugs)) {
        result.vst3 = filterRate(emPlugsV3.emVst3Plugs, value)
    }
    return result.vst2.concat(result.vst3)
}
// 获取拟人参数
export const getEmHumanize = (emPlugsV3, value) => {
    const result = {
        vst2: [],
        vst3: [],
    }
    if (Array.isArray(emPlugsV3.emPlugs)) {
        result.vst2 = filterHumanize(emPlugsV3.emPlugs, value)
    }
    if (Array.isArray(emPlugsV3.emVst3Plugs)) {
        result.vst3 = filterHumanize(emPlugsV3.emVst3Plugs, value)
    }
    return result.vst2.concat(result.vst3)
}
// 获取弹性参数
export const getEmFlex = (emPlugsV3, value) => {
    const result = {
        vst2: [],
        vst3: [],
    }
    if (Array.isArray(emPlugsV3.emPlugs)) {
        result.vst2 = filterFlex(emPlugsV3.emPlugs, value)
    }
    if (Array.isArray(emPlugsV3.emVst3Plugs)) {
        result.vst3 = filterFlex(emPlugsV3.emVst3Plugs, value)
    }
    return result.vst2.concat(result.vst3)
}
// 获取颤音参数
export const getEmVibrato = (emPlugsV3, value) => {
    const result = {
        vst2: [],
        vst3: [],
    }
    if (Array.isArray(emPlugsV3.emPlugs)) {
        result.vst2 = filterVibRato(emPlugsV3.emPlugs, value)
    }
    if (Array.isArray(emPlugsV3.emVst3Plugs)) {
        result.vst3 = filterVibRato(emPlugsV3.emVst3Plugs, value)
    }
    return result.vst2.concat(result.vst3)
}
// 获取跟踪参数
export const getEmTracking = (emPlugsV3, value) => {
    const result = {
        vst2: [],
        vst3: [],
    }
    if (Array.isArray(emPlugsV3.emPlugs)) {
        result.vst2 = filterTracking(emPlugsV3.emPlugs, value)
    }
    if (Array.isArray(emPlugsV3.emVst3Plugs)) {
        result.vst3 = filterTracking(emPlugsV3.emVst3Plugs, value)
    }
    return result.vst2.concat(result.vst3)
}
// 获取输入类型参数
export const getInputType = (emPlugsV3, inputType) => {
    const result = {
        vst2: [],
        vst3: [],
    }
    if (Array.isArray(emPlugsV3.emPlugs)) {
        result.vst2 = filterInputType(emPlugsV3.emPlugs, inputType)
    }
    if (Array.isArray(emPlugsV3.emVst3Plugs)) {
        result.vst3 = filterInputType(emPlugsV3.emVst3Plugs, inputType)
    }
    return result.vst2.concat(result.vst3)
}
/**
 * 获取消除人声参数
 * value为0到100整数 50-0开始消除人声伴奏不变 0消除所有人声 
 * 50-100开始消除伴奏 人声不变 100消除所有伴奏
 * @param {Object} emPlugsV3 
 * @param {value} value 
 * @returns 
 */
export const getRemoveVocals = (emPlugsV3, value) => {
    const result = {
        vst2: [],
        vst3: [],
    }
    if (Array.isArray(emPlugsV3.emPlugs)) {
        result.vst2 = filterRemoveVocals(emPlugsV3.emPlugs, value)
    }
    if (Array.isArray(emPlugsV3.emVst3Plugs)) {
        result.vst3 = filterRemoveVocals(emPlugsV3.emVst3Plugs, value)
    }
    return result.vst2.concat(result.vst3)
}

// 筛选基调和音阶
function filterKeynote(plugs, emKeynote, emKey) {
    const result = []
    plugs.forEach(ele => {
        if (ele.emKeynote && emKeynote in ele.emKeynote) {
            result.push({
                uniqueId: ele.uniqueId,
                pluginName: ele.plugName,
                pluginType: formatVstVersion(ele.emVer),
                index: completeParam(ele.emKeynote[emKeynote].index),
                value: completeParam(ele.emKeynote[emKeynote].value),
            })
        }
        if (ele.emKey && emKey in ele.emKey) {
            result.push({
                uniqueId: ele.uniqueId,
                pluginName: ele.plugName,
                pluginType: formatVstVersion(ele.emVer),
                index: completeParam(ele.emKey[emKey].index),
                value: completeParam(ele.emKey[emKey].value),
            })
        }
        if (ele.emKeyboard) {
            const keyboardResult = filterKeyboardKeynote(ele, emKeynote, emKey);
            keyboardResult.forEach(el => {
                result.push(el)
            })
        }
    });
    return result
}
// 生成emKeyboard类型的基调参数列表
function filterKeyboardKeynote(plug, emKeynote, emKey) {
    if (emKey === "Chromatic") {
        return plug.emKeyboard.map(ele => {
            return {
                index: ele,
                pluginName: plug.plugName,
                pluginType: formatVstVersion(plug.emVer),
                uniqueId: undefined,
                value: 1
            }
        })
    }
    // 大调调式 全全半全全全半
    const majorMode = [1,0,1,0,1,1,0,1,0,1,0,1]
    // 小调调式 全半全全半全全
    const minorMode = [1,0,1,1,0,1,0,1,1,0,1,0]
    const mode = emKey === "Minor" ? minorMode : majorMode
    const result = []
    // 找出key在键盘上的序号
    let index = keynoteConfig.findIndex(ele => {
        return ele.matchValue.some(el => el === emKeynote)
    })
    // 拆分参数列表 重新排序 按照调式顺序传入
    const first = plug.emKeyboard.slice(0, index)
    const last = plug.emKeyboard.slice(index)
    const emKeyboard = last.concat(first)
    emKeyboard.forEach((plugIndex, i) => {
        result.push({
            index: plugIndex,
            pluginName: plug.plugName,
            pluginType: formatVstVersion(plug.emVer),
            uniqueId: plug.uniqueId,
            value: mode[i] === undefined ? mode[i - 12] : mode[i]
        })
    })
    return result
}
// 筛选升降调
function filterTune(plugs, tune) {
    const result = [];
    plugs.forEach(ele => {
        if (ele.tune) {
            const p = getTuneParam(ele.tune, tune);
            if (p) {
                result.push({
                    uniqueId: ele.uniqueId,
                    pluginName: ele.plugName,
                    pluginType: formatVstVersion(ele.emVer),
                    index: p.index,
                    value: p.value,
                })
            }
        }
        if (Array.isArray(ele.tuneRangeExtend)) {
            ele.tuneRangeExtend.forEach(e => {
                result.push({
                    uniqueId: ele.uniqueId,
                    pluginName: ele.plugName,
                    pluginType: formatVstVersion(ele.emVer),
                    index: completeParam(e.index),
                    value: completeParam(e.value),
                    plugMinVernum: e.plugMinVernum,
                })
            })
        } else {
            if (ele.tuneRange) {
                result.push({
                    uniqueId: ele.uniqueId,
                    pluginName: ele.plugName,
                    pluginType: formatVstVersion(ele.emVer),
                    index: completeParam(ele.tuneRange.index),
                    value: completeParam(ele.tuneRange.value),
                })
            }
        }
    })
    return result;
}
function getTuneParam(tuneObj, tune) {
    try {
        let r = null;
        for (const key in tuneObj) {
            if (parseInt(key, 10) === tune) {
                r = {
                    index: completeParam(tuneObj[key].index),
                    value: completeParam(tuneObj[key].value),
                }
            }
        }
        return r
    } catch (error) {
        return null;
    }   
}
// 筛选速率参数
function filterRate(plugs, value) {
    const rateValue = emRateConfig[parseInt(value, 10)];
    const wavesRateValue = wavesEmRateConfig[parseInt(value, 10) * 2];
    const xpitchRateValue = xpitchEmRateConfig[parseInt(value, 10)]
    const result = []
    plugs.forEach(ele => {
        if (typeof ele.speedStep === "number") {
            let val = 0
            if (ele.plugName === "紫色电音") {
                val = wavesRateValue
            } else if (ele.plugName === "xpitch") {
                val = xpitchRateValue
            } else {
                val = rateValue
            }
            result.push({
                uniqueId: ele.uniqueId,
                pluginName: ele.plugName,
                pluginType: formatVstVersion(ele.emVer),
                index: completeParam(ele.speedIndex),
                value: val,
            })
        }
    });
    return result
}
// 筛选拟人参数
function filterHumanize(plugs, value) {
    const result = []
    plugs.forEach(ele => {
        if (typeof ele.humanizeTuneStep === "number") {
            result.push({
                uniqueId: ele.uniqueId,
                pluginName: ele.plugName,
                pluginType: formatVstVersion(ele.emVer),
                index: completeParam(ele.humanizeTuneIndex),
                value: getValueBySetp(value, ele.humanizeTuneStep),
            })
        }
    });
    return result
}
// 筛选弹性参数
function filterFlex(plugs, value) {
    const result = []
    plugs.forEach(ele => {
        if (typeof ele.flexTuneStep === "number") {
            result.push({
                uniqueId: ele.uniqueId,
                pluginName: ele.plugName,
                pluginType: formatVstVersion(ele.emVer),
                index: completeParam(ele.flexTuneIndex),
                value: getValueBySetp(value, ele.flexTuneStep),
            })
        }
    });
    return result
}
// 筛选颤音参数
function filterVibRato(plugs, value) {
    const result = []
    const vibRatoVal = (value - (-12))/(12 - (-12));
    plugs.forEach(ele => {
        if (typeof ele.vibratoStep === "number") {
            result.push({
                uniqueId: ele.uniqueId,
                pluginName: ele.plugName,
                pluginType: formatVstVersion(ele.emVer),
                index: completeParam(ele.vibratoIndex),
                value: vibRatoVal,
            })
        }
    });
    return result
}
// 筛选跟踪参数
function filterTracking(plugs, value) {
    const result = []
    const trackingVal = (value - 1)/(100 - 1);
    plugs.forEach(ele => {
        if (typeof ele.trackingStep === "number") {
            result.push({
                uniqueId: ele.uniqueId,
                pluginName: ele.plugName,
                pluginType: formatVstVersion(ele.emVer),
                index: completeParam(ele.trackingIndex),
                value: trackingVal,
            })
        }
    });
    return result
}
// 筛选输入类型参数
function filterInputType(plugs, inputType) {
    const result = [];
    plugs.forEach(ele => {
        if (ele.emInputType && ele.emInputType[inputType]) {
            result.push({
                uniqueId: ele.uniqueId,
                pluginName: ele.plugName,
                pluginType: formatVstVersion(ele.emVer),
                index: completeParam(ele.emInputType[inputType].index),
                value: completeParam(ele.emInputType[inputType].value),
            })
        }
    });
    return result;
}

// 筛选消除人声参数
function filterRemoveVocals(plugs, value) {
    const result = [];
    const found = plugs.find(ele => ele.plugName === "消人声");
    if (!found) {
        return result;
    }
    found.params.forEach(ele => {
        result.push({
            uniqueId: found.uniqueId,
            pluginName: found.plugName,
            pluginType: formatVstVersion(found.emVer),
            index: completeParam(ele.index),
            value: getRemoveVocalsParam(ele, value),
        })
    })
    return result;
}

// 根据value获取不同的参数值
function getRemoveVocalsParam(param, value) {
    if (value === 50) {
        return param.value
    }
    if (value < 50) {
        if (param.paramName === "vocals") {
            return parseFloat(value / 50 * param.value)
        } else {
            return param.value
        }
    }
    if (value > 50) {
        if (param.paramName === "vocals") {
            return param.value
        } else {
            return parseFloat((100 - value) / 50 * param.value)
        }
    }
}

/**
 * 补全插件参数 undefined默认为0
 * @param {Number} val 
 * @returns {Number}
 */
function completeParam(val) {
    if (val !== void 0) {
        return val
    }
    return 0
}

/**
 * 格式化vst版本
 * @param {String} emVer 
 * @returns {String}
 */
function formatVstVersion(emVer) {
    return emVer === "EM_VERSION_2" ? "vst2" : "vst3"
}

/**
 * 根据步长和百分比值获取参数值
 * @param {Number} value 
 * @param {Number} step 
 */
function getValueBySetp(value, step) {
    if (typeof value !== "number" || typeof step !== "number") {
        return 0
    }
    const p = value * step
    return p > 1 ? 1 : p
}

